
import React from "react";
import ProductCard from "@/components/ProductCard";

const ProductExample = () => {
  const productData = {
    productName: "Dior Addict Lip Glow",
    description: "Moisturizing lip balm",
    price: "42.00 €",
    rating: 4.7,
    reviews: 124,
    availability: "In stock",
    mpn: "Y0996458",
    brand: "Dior",
    imageUrl: "/lovable-uploads/6ab3556b-2793-445d-a903-90845bced60e.png",
    productUrl: "https://www.dior.com/en_us/products/beauty-Y0996458-dior-addict-lip-glow",
    breadcrumb: ["Beauty", "Makeup", "Lips", "Lip balm"],
    customerReview: "I love it! Moisturizing and the shade is perfect!",
    reviewAuthor: "Claire M."
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 to-indigo-950 py-10 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-center mb-8 text-gradient-tech">Tech Product Display</h1>
        <ProductCard {...productData} />
      </div>
    </div>
  );
};

export default ProductExample;
